import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  company: Yup.number().required(),
});
